import { Box, Chip, Paper, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';

import {
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';
import {
  formatDateTime,
  formatInstallments,
  getPreAdjudicationChipColor,
} from '../../utils/puntajeFormatters';
import TableStateRow from '../common/TableStateRow';

const PreAdjudicationsTable = ({ title, rows, isLoading, pagination }) => (
  <Paper
    elevation={0}
    sx={{ p: 2.5, borderTop: '1px solid', borderColor: 'divider', borderRadius: 0 }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
      {title}
    </Typography>
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell>Fecha</HeadTableCell>
            <HeadTableCell>Contrato</HeadTableCell>
            <HeadTableCell>Suscriptor(es)</HeadTableCell>
            <HeadTableCell>Motivo</HeadTableCell>
            <HeadTableCell>Fondo</HeadTableCell>
            <HeadTableCell sx={{ textAlign: 'right' }}>Debito</HeadTableCell>
            <HeadTableCell>Usuario</HeadTableCell>
            <HeadTableCell>Loteria</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows.length ? (
            <TableStateRow colSpan={8} loading={isLoading} emptyMessage="No hay registros para este tipo." />
          ) : (
            rows.map((row) => (
              <TableRow key={row.uuid} hover>
                <RowTableCell>{formatDateTime(row.confirmed_at)}</RowTableCell>
                <RowTableCell>{row.contract_number}</RowTableCell>
                <RowTableCell>{(row.subscriber_names || []).join(', ') || '-'}</RowTableCell>
                <RowTableCell>
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Chip
                      label={row.pre_adjudication_type}
                      color={getPreAdjudicationChipColor(row.pre_adjudication_type)}
                      size="small"
                    />
                  </Box>
                </RowTableCell>
                <RowTableCell>{row.fund_type}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'right', fontWeight: 600 }}>
                  {formatInstallments(row.debited_installments)}
                </RowTableCell>
                <RowTableCell>{row.user_names || '-'}</RowTableCell>
                <RowTableCell>{row.lottery_full_number || '-'}</RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
    {!!pagination?.totalCount && (
      <PaginationTable
        page={pagination.page}
        totalPages={pagination.totalPages}
        totalCount={pagination.totalCount}
        rowsPerPage={pagination.rowsPerPage}
        onPageChange={pagination.handlePageChange}
        onRowsPerPageChange={pagination.handleRowsPerPageChange}
      />
    )}
  </Paper>
);

export default PreAdjudicationsTable;
